import React, { ReactElement } from 'react';

interface Props {
  className?: string;
  checked: boolean;
  checkedIcon: ReactElement;
  icon: ReactElement;
  disabled?: boolean;
  onChange?: () => void;
  id?: string;
}

export const MainCheckBox = ({ className = '', checked, onChange, id = '', icon, checkedIcon, disabled }: Props) => {
  return (
    <span className={`main-checkbox ${className} ${disabled ? 'disabled' : ''}`} onChange={onChange}>
      <span className="main-checkbox-container">
        <input
          className="main-checkbox-input"
          id={id}
          type="checkbox"
          value=""
          data-indeterminate="false"
          aria-label="Check the variant"
        />
        {checked ? checkedIcon : icon}
      </span>
    </span>
  );
};
